var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.354 25.6h29.292c-.661 1.593-2.107 4.05-4.989 5.17-2.09.83-5.907 1.197-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23-2.88-1.12-4.327-3.577-4.988-5.17ZM.106 12.8h31.8c.079 1.105.104 2.186.09 3.216a35.087 35.087 0 0 1-.102 3.184H.097a37.111 37.111 0 0 1-.094-3.217A35.103 35.103 0 0 1 .106 12.8Zm30.56-6.4H1.354c.66-1.593 2.107-4.051 4.989-5.17C8.433.431 12.25.032 16 0c3.75.033 7.567.432 9.691 1.263 2.861 1.111 4.307 3.544 4.975 5.137Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568L16 16 3.308 28.692Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6 17.6-2.351 1.636.83-2.742-2.283-1.73 2.864-.058L6 12l.94 2.706 2.864.058-2.282 1.73.83 2.742L6 17.6Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagPri = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagPri_default = SvgFlagPri;
export {
  FlagPri_default as default
};
